const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/item", "/item"],
    exact: true,
    component: "SingleItem",
  },
];

export default routes;
